const routes = [
    {
        path: "/finance/supervisor-reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    },
];

export default routes;
